// extracted by mini-css-extract-plugin
export default {"container":"Vdlsh865oCcodnX9PyBM","item":"sUePZZmYVt_lZy_7LGFe","label":"I0EFIqWPvJO0InVs7Oun"};